import DOMPurify from 'dompurify';
import { descriptionBlocks } from './careersOptions';

// Formatting kept in job descriptions; everything else (styles, scripts, images…) is stripped
const ALLOWED_TAGS = ['p', 'br', 'strong', 'b', 'em', 'i', 'u', 'ul', 'ol', 'li', 'h3', 'h4', 'a'];

let linkHookAdded = false;
const addLinkHook = () => {
  if (linkHookAdded) return;
  // External links in descriptions open in a new tab without access to our page
  DOMPurify.addHook('afterSanitizeAttributes', (node) => {
    if (node.tagName === 'A') {
      node.setAttribute('target', '_blank');
      node.setAttribute('rel', 'noopener noreferrer');
    }
  });
  linkHookAdded = true;
};

export const sanitizeHtml = (html) => {
  addLinkHook();
  return DOMPurify.sanitize(html || '', {
    ALLOWED_TAGS,
    ALLOWED_ATTR: ['href', 'target', 'rel'],
    ALLOWED_URI_REGEXP: /^(https?:|mailto:)/i
  });
};

const escapeHtml = (text) => text
  .replace(/&/g, '&amp;')
  .replace(/</g, '&lt;')
  .replace(/>/g, '&gt;');

// Offers written before the rich-text editor were plain text with "- " bullets
export const plainToHtml = (text) => descriptionBlocks(text)
  .map(block => (block.type === 'list'
    ? `<ul>${block.items.map(item => `<li>${escapeHtml(item)}</li>`).join('')}</ul>`
    : `<p>${escapeHtml(block.text)}</p>`))
  .join('');

export const descriptionHtml = (job) => (job.descriptionFormat === 'html'
  ? sanitizeHtml(job.description)
  : plainToHtml(job.description));

// Text version for excerpts and meta descriptions
export const htmlToText = (html) => {
  const container = document.createElement('div');
  container.innerHTML = sanitizeHtml((html || '').replace(/<\/(p|li|h3|h4)>|<br\s*\/?>/gi, ' $&'));
  return (container.textContent || '').replace(/\s+/g, ' ').trim();
};

export const descriptionText = (job) => (job.descriptionFormat === 'html'
  ? htmlToText(job.description)
  : (job.description || '').replace(/^[-•*]\s+/gm, '').replace(/\s+/g, ' ').trim());
